import { type GrapeAPIErrorType } from '../hooks/GrapeAPIError'
import { Banner, ErrorListBanner } from '../reusable/Banner'

export function InfoBanner () {
  return (
    <Banner
      type='default'
      titleText='Upload a new census or use a previous census'
    >
      <p>
        Thatch stores the censuses you have used in the past so that you don't
        have to upload the same file twice. If you choose to upload a new file,
        please first select the corresponding payroll provider and then select a
        file to upload from the selected payroll provider.
      </p>
    </Banner>
  )
}

export function BeingProcessedBanner () {
  return (
    <Banner type='attention' titleText='Your census file is being processed'>
      <p>
        The census may take a while to process. You will be notified via Slack
        once the file is finished uploading, at which point you may continue
        creating your quote.
      </p>
      <p>
        Your progress has been saved and you may close this window. You may
        access your progress by clicking on the most recent entry with an “in
        progress” status in the Quotes table under Prospect detail page.
      </p>
    </Banner>
  )
}

export function ProblemCreatingCensus ({
  errors,
}: {
  errors: GrapeAPIErrorType;
}) {
  return (
    <Banner type='critical' titleText='Problem creating census'>
      <p className='mb-4'>
        There was a problem creating the census for this prospect and the file
        has not been uploaded. Error message: {errors.message}
      </p>
      {errors.errors && (
        <ul className='mb-4'>
          {errors.errors.map((errorMsg, index) => (
            <li key={`api-error-${index}`}>{errorMsg}</li>
          ))}
        </ul>
      )}
    </Banner>
  )
}

export function ProblemGeneratingBenchmark ({
  error,
}: {
  error: GrapeAPIErrorType;
}) {
  return (
    <Banner type='warning' titleText='Problem generating benchmark'>
      <p className='mb-4'>
        There was a problem generating benchmark for this quote. Error message:{' '}
        {error.message}
      </p>
      {error.errors && (
        <ul className='mb-4'>
          {error.errors.map((errorMsg, index) => (
            <li key={`api-error-${index}`}>{errorMsg}</li>
          ))}
        </ul>
      )}
      <p>
        You can also skip this step and continue with generating the quote
        without seeing the benchmark.
      </p>
    </Banner>
  )
}

export function CensusParsingError ({ errors }: { errors: string[] }) {
  return (
    <ErrorListBanner
      errors={errors}
      titleText='Census parsing errors'
      genericErrorMessage={`There ${errors.length > 1 ? 'were' : 'was'} ${
        errors.length
      } ${
        errors.length > 1 ? 'errors' : 'error'
      } encountered while parsing the census
        file. Please refer to the errors below:`}
    />
  )
}

export function CensusUploaded () {
  return (
    <Banner
      type='success'
      titleText='Your census has been successfully uploaded!'
    >
      <p>
        Please proceed by clicking the "Next" button at the bottom of the
        screen.
      </p>
    </Banner>
  )
}
